import { Component, OnInit, OnChanges, SimpleChanges, Input, Output, EventEmitter, ViewChild, ElementRef, ViewEncapsulation, OnDestroy } from '@angular/core';

import { DataService, HelperService } from 'app/services';

import { findIndex, omit, xor } from 'lodash';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

interface placeholderTexts {
  searchPlaceolder: string;
  allListPlaceholder: string;
}

@Component({
  selector: 'app-multiple-filter',
  templateUrl: './app-multiple-filter.component.html',
  styleUrls: ['./app-multiple-filter.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AppMultipleFilterComponent implements OnInit, OnChanges, OnDestroy {
  @Input() type: any = 'tag';
  @Input() data: any = [];
  @Input() listData: any = [];
  @Input() nameField: string = 'name';
  @Input() scrollHeight: string = '180px';
  @Input() preCheckedTags: any = [];
  @Input() grayCheckbox: boolean = false;
  @Input() childData: boolean = false;
  @Input() isSelectAll: boolean = false;
  @Input() isTextCompany: boolean = false;
  @Input() isSearchSelect: boolean = false;
  @Input() countField: string = 'count';
  @Input('multipleFilterData')
  set setMultipleFilterData(data: any[]) {
    this.data = this.helperService.deepCopy(data);
    this.isMultipleGenericFiltersEnabled = true;
  }
  @Input('multipleFilterListData')
  set setMultipleFilterListData(data: any[]) {
    this.listData = this.helperService.deepCopy(data);
    this.isMultipleGenericFiltersEnabled = true;
  }
  @Input() multipleSearchPlaceholders: placeholderTexts = {
    searchPlaceolder: 'Search supplier',
    allListPlaceholder: 'All suppliers',
  };

  @Output() appChangeFilter = new EventEmitter<any>();

  @ViewChild('multiDropdownContainer', { static: true }) multiDropdownContainer: ElementRef;

  masterSelected: boolean;
  checkedList: any;
  query: any = '';
  isSearching: boolean = false;
  selectedData: any = [];
  isMutliDropdownVisible: boolean = false;
  isMultipleGenericFiltersEnabled: boolean = false;
  private unsubscribe: Subject<boolean> = new Subject<boolean>();

  constructor(private dataService: DataService, private helperService: HelperService) {}
   


  ngOnInit() {
    this.retainFiltersAfterPageReload()
    this.isTextCompany = this.dataService.isCompanyTextShow;
    if (this.isSelectAll) {
      this.masterSelected = false;
      this.dataService.getData().subscribe((x) => {
        if (x.data.key === 'clearSelectAllFilter') {
          if (x.data.data) this.masterSelected = false;
        }
      });
    }
    this.setClickOutSideListeners();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.hasOwnProperty('data')) {
      if (!changes['data'].firstChange) {
        if (this.data && this.data.length > 0) {
          this.setClickOutSideListeners();
        }
      }
    } else if (changes.hasOwnProperty('multipleSearchPlaceholders')) {
      if (this.isSearchSelect && !Object.keys(changes['multipleSearchPlaceholders'].currentValue || {}).length) {
        this.multipleSearchPlaceholders = {
          searchPlaceolder: 'Search supplier',
          allListPlaceholder: 'All suppliers',
        };
      }
    }
  }

  retainFiltersAfterPageReload(){
    try{
      const storedFilters = JSON.parse(localStorage.getItem('selectedFilters') || '[]');
      if (storedFilters.length > 0) {
        this.data.forEach((item: any) => {
          const matchedFilter = storedFilters.find((filter: any) => filter.name === item.name);
          if (matchedFilter) {
            item.isChecked = true;
          }
        });
      }
    }catch(error){
      console.log(error)
    }
  }

  setClickOutSideListeners() {
    this.dataService
      .getClickEvent()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((target) => {
        if (this.multiDropdownContainer.nativeElement.contains(target)) {
        } else {
          this.toggleDropdown();
          if (!this.isMutliDropdownVisible) {
            this.query = '';
            this.selectedData = [];
            this.data.filter((data) => {
              if (data.isChecked) this.selectedData.push(data);
            });
            this.onSearchSupplier(this.query);
          }
        }
      });
  }

  toggleDropdown() {
    this.isMutliDropdownVisible = !this.isMutliDropdownVisible;
  }

  viewChildData({ field }) {
    if (this.childData && ['isMarketingEnabled', 'isMarketingPaid'].includes(field)) {
      return true;
    } else return false;
  }

  viewMarketingTrial({ field }) {
    if (this.childData && (field === 'isMarketingTrial' || field === 'isMarketingPaid')) {
      return true;
    } else return false;
  }

  toggleSelect(data: any) {
    data.isChecked = !data.isChecked;
    this.emitSelectedTags();
  }

  onChange(data: any, event: any) {
    data.isChecked = event;
    this.emitSelectedTags();
  }

  emitSelectedTags() {
    const filtered = this.data.filter((data: any) => data.isChecked && !data.isHeader);
    this.appChangeFilter.emit(filtered);
  }

  checkExistingMarketingChecked({ field, isChecked }) {
    const marketingConnectedFlag = xor(['isMarketingEnabled', 'isMarketingTrial', 'isMarketingPaid'], [field]);

    this.data.forEach((featureFlag: any) => {
      if (marketingConnectedFlag.includes(featureFlag.field)) {
        featureFlag.isChecked = false;
      }
    });
  }

  onOptionClick(data: any, listIndex?: number) {
    data.isChecked = !data.isChecked;
    if (this.isMultipleGenericFiltersEnabled) {
      if (listIndex >= 0) {
        this.data[listIndex].isChecked = data.isChecked;
      }
    }

    if (data.value && !data.isHeader) {
      if (!data.isChecked) {
        const headerIndex = findIndex(this.data, { isHeader: true, value: data.value });

        if (this.data[headerIndex]) this.data[headerIndex].isChecked = false;
      } else {
        const itemIndex = findIndex(this.data, ({ value, isHeader, isChecked }) => !isHeader && !isChecked && value === data.value);

        if (itemIndex === -1) {
          const headerIndex = findIndex(this.data, { isHeader: true, value: data.value });
         
          if (this.data[headerIndex]) this.data[headerIndex].isChecked = true;
        }
      }
    }

    if (data.isHeader && data.value) {
      this.data.forEach((item: any) => {
        if (item.value === data.value) {
          item.isChecked = data.isChecked;
        }
      });
    }
    if (this.isSelectAll) this.getCheckedItemList();
    this.emitSelectedTags();

    // if marketingPaid is check uncheckoed IsMarketingTrial and vice versa
    if (data.field === 'isMarketingPaid' && data.isChecked) {
      const headerIndex = this.data.findIndex((o) => o.field === 'isMarketingTrial');
      if (this.data[headerIndex].isChecked) {
        this.data[headerIndex].isChecked = false;
        this.emitSelectedTags();
      }
    }
    if (data.field === 'isMarketingTrial' && data.isChecked) {
      const headerIndex = this.data.findIndex((o) => o.field === 'isMarketingPaid');
      if (this.data[headerIndex].isChecked) {
        this.data[headerIndex].isChecked = false;
        this.emitSelectedTags();
      }
    }

    if (this.isSearchSelect) {
      this.selectedData = [];
      this.listData.filter((data) => {
        if (data.isChecked) this.selectedData.push(data);
      });
      // this.query = '';
      this.listData = this.data.filter(({ name }) => name.toLowerCase().includes(this.query));
    }
  }

  // Check All Checkbox Checked
  isAllSelected() {
    this.masterSelected = !this.masterSelected;
    this.data.map((item) => (item.isChecked = this.masterSelected));
    this.getCheckedItemList();
  }

  // The master checkbox will check/ uncheck all items
  checkUncheckAll() {
    for (var i = 0; i < this.data.length; i++) {
      this.data[i].isChecked = this.masterSelected;
    }
    this.getCheckedItemList();
  }

  // Get List of Checked Items
  getCheckedItemList() {
    this.checkedList = [];
    for (var i = 0; i < this.data.length; i++) {
      if (this.data[i].isChecked) this.checkedList.push(this.data[i]);
    }
    if (this.checkedList.length === this.data.length) {
      this.masterSelected = true;
    } else this.masterSelected = false;
    this.emitSelectedTags();
  }

  searchSelectAll(){
    this.listData.forEach((item) => (item.isChecked = true));
    this.selectedData = [...this.listData];
    this.getCheckedItemList();
  }

  searchClear(){
    this.query = ''
    this.masterSelected = false;
    this.checkUncheckAll();
    this.selectedData = []
    this.listData = this.helperService.deepCopy(this.data);
  }

  onSearchSupplier(e: any) {
    this.query = e.toLowerCase();
    if (this.query === '') {
      this.listData = this.data;
    }
    this.listData = this.data.filter((data) => {
      if (data.isChecked || this.query === '') {
        this.isSearching = true;
      } else this.isSearching = false;
      if (data.name) {
        return data.name.toLowerCase().includes(this.query);
      } else if (data.value) {
        return data.value.toLowerCase().includes(this.query);
      } else {
        return data;
      }
    });
  }

  ngOnDestroy() {
    this.unsubscribe.next(true);
    this.unsubscribe.unsubscribe();
    this.dataService.isCompanyTextShow = false;
  }
}
